import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './components/App.vue'
import router from './router'
import store, { ActionTypes } from './store'
import { caricaBranding } from './api/branding'
import { setupServiceWorkerUpdateHandler } from './sw-update-handler'
import './pwa-handler.js'

import 'bootstrap/dist/css/bootstrap.min.css'
import '@coreui/coreui-pro/dist/css/coreui.min.css'
import 'sweetalert2/dist/sweetalert2.min.css'

// FontAwesome: si registrano solo le icone usate (menu, layout, pagine).
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faAddressCard, faArrowLeft, faArrowUpRightFromSquare, faBars, faCalculator, faChartColumn,
  faCheck, faCircleCheck, faCircleInfo, faCodeMerge, faCopy, faDownload, faEuroSign, faFileCsv,
  faFileInvoiceDollar, faFilter, faFloppyDisk, faGaugeHigh, faHammer, faIndustry, faMagnifyingGlass, faMoon,
  faNoteSticky, faPenToSquare, faPercent, faPlus, faRightFromBracket, faRotate, faSun, faTrashCan,
  faTriangleExclamation, faUser, faUserShield, faXmark,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faAddressCard, faArrowLeft, faArrowUpRightFromSquare, faBars, faCalculator, faChartColumn,
  faCheck, faCircleCheck, faCircleInfo, faCodeMerge, faCopy, faDownload, faEuroSign, faFileCsv,
  faFileInvoiceDollar, faFilter, faFloppyDisk, faGaugeHigh, faHammer, faIndustry, faMagnifyingGlass, faMoon,
  faNoteSticky, faPenToSquare, faPercent, faPlus, faRightFromBracket, faRotate, faSun, faTrashCan,
  faTriangleExclamation, faUser, faUserShield, faXmark,
)

setupServiceWorkerUpdateHandler()

async function initApp() {
  try {
    // CoreUI Pro è pesante: lo si carica in un chunk separato. Intanto arriva
    // dall'API il marchio dell'azienda (nome, logo, colore della sidebar).
    const [CoreuiVue] = await Promise.all([import('@coreui/vue-pro'), caricaBranding()])

    // Ripristina la sessione da localStorage (la valida poi il guard del router).
    await store.dispatch(ActionTypes.CHECK_AUTH_ON_LOAD)

    const app = createApp(App)
    app.use(CoreuiVue.default)
    app.use(createPinia())
    app.use(router)
    app.use(store)
    app.component('font-awesome-icon', FontAwesomeIcon)
    app.mount('#app')

    sessionStorage.removeItem('app_init_retry')
  } catch (error) {
    console.error("Errore durante l'inizializzazione dell'app:", error)

    // Un chunk non trovato dopo un deploy si risolve ricaricando: si riprova una volta.
    if (!sessionStorage.getItem('app_init_retry')) {
      sessionStorage.setItem('app_init_retry', '1')
      window.location.reload()
      return
    }

    document.getElementById('app')!.innerHTML = `
      <div style="display:flex;align-items:center;justify-content:center;height:100vh;flex-direction:column;font-family:Arial,sans-serif;">
        <h2>Errore di caricamento</h2>
        <p>Si è verificato un errore durante il caricamento dell'applicazione.</p>
        <button onclick="window.location.reload()" style="padding:10px 20px;margin-top:20px;cursor:pointer;">
          Ricarica la pagina
        </button>
      </div>
    `
  }
}

initApp()
